@let tenantRoute = (this.route$() | async) ?? '';
<cam-loader [isLoading]="this.requestState.isLoading()">
  <cam-error [message]="this.requestState.getErrorMessage()" [code]="this.requestState.getErrorStatus()">
    @if (this.display() === 'icon') {
      <cam-font-icon [name]="'arrow-big-right'" type="lg" (click)="this.navigateToTenant(tenantRoute)"></cam-font-icon>
    } @else if (this.display() === 'button') {
      <cam-button [type]="'secondary'" (action)="this.navigateToTenant(tenantRoute)">
        <ng-content></ng-content>
      </cam-button>
    }
  </cam-error>
</cam-loader>
